export function mfaPresentation(summary) {
  const status = summary && summary.status;
  const date = summary && summary.lastLoginVerifiedAt;
  const when = date && Number.isFinite(new Date(date).getTime())
    ? ` Last login MFA: ${new Date(date).toLocaleString()}.` : "";
  if (status === "verified_trusted") return {
    label: "Login MFA verified", tone: "verified",
    description: "Login MFA completed · Verified device still trusted." + when,
  };
  if (status === "trusted_device") return {
    label: "Trusted device", tone: "trusted",
    description: "An active trusted device is recorded. Its trust may come from signup/contact OTP, support, or another login flow; the source is not confirmed. This is not proof of completed login MFA." + when,
  };
  if (status === "previously_verified") return {
    label: "Previously verified", tone: "neutral",
    description: "Previously verified · No active MFA-verified device." + when,
  };
  if (status === "not_recorded") return {
    label: "No verification recorded", tone: "neutral",
    description: "No login MFA completion recorded. Device trust alone does not confirm login MFA.",
  };
  return { label: "Unavailable", tone: "unavailable", description: "MFA status unavailable. This does not mean MFA is disabled." };
}
